import React, { createContext, useContext } from 'react';

type OaAppContextValue = {
  embedded: boolean;
};

const OaAppContext = createContext<OaAppContextValue>({ embedded: false });

export function OaAppProvider({
  children,
  embedded = true,
}: {
  children: React.ReactNode;
  embedded?: boolean;
}): React.ReactElement {
  return <OaAppContext.Provider value={{ embedded }}>{children}</OaAppContext.Provider>;
}

export function useOaApp(): OaAppContextValue {
  return useContext(OaAppContext);
}
